import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './rootreducer.js';
import adobeDtmMiddleware from './../middleware/adobeDtm';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

function persistState(state) {
  try {
    const stateToPersist = {
      homeReducers: state.homeReducers,
      commonReducers: state.commonReducers,
      headerReducers: state.headerReducers,
      bObSummaryReducers: {
        rowSummary: state.bObSummaryReducers.rowSummary,
        isInternalUser: state.bObSummaryReducers.isInternalUser,
      },
      renewalsSummaryReducers: {
        rowSummary: state.renewalsSummaryReducers.rowSummary,
      },
      bobClientDetailsReducers: state.bobClientDetailsReducers,
      renewalsDetailsReducers: state.renewalsDetailsReducers,
      employeeReducer: state.employeeReducer,
      accountDetailsReducer: state.accountDetailsReducer,
      detailsContainerReducer: state.detailsContainerReducer,
      sgqReducers: state.sgqReducers,
      dashboardReducer: state.dashboardReducer,
    };
    const serializedState = JSON.stringify(stateToPersist);
    if (!window.location.href.includes('logout')) {
      sessionStorage.setItem('state', serializedState);
    } else {
      sessionStorage.setItem('state', '');
    }
  } catch (err) {
    console.log(err);
  }
}

function rehydrateState() {
  try {
    const serializedState = sessionStorage.getItem('state');

    if (serializedState === null || serializedState === '') {
      if (window.location.search !== '') {
        window.isSimulation = true;
        window.simulationHeader = window.location.search;
      }

      return undefined;
    }
    const parsedState = JSON.parse(serializedState);

    if (window.location.search !== '') {
      window.isSimulation = true;
      window.simulationHeader = window.location.search;
    } else if (
      parsedState.homeReducers &&
      parsedState.homeReducers.bpUserInfo &&
      parsedState.homeReducers.bpUserInfo.isSimulation
    ) {
      window.isSimulation = parsedState.homeReducers.bpUserInfo.isSimulation;
      window.simulationHeader = parsedState.homeReducers.bpUserInfo.simulationHeader;
    }

    return parsedState;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

const persistedState = rehydrateState();

const store = createStore(
  rootReducer,
  { ...persistedState },
  composeEnhancers(applyMiddleware(...[thunk, adobeDtmMiddleware]))
);

store.subscribe(() => persistState(store.getState()));

export default store;
